<template>
  <div>
    <b-alert
        show
        variant="light"
        class="alert alert-custom alert-white alert-shadow fade show gutter-b"
    >
      <div class="alert-icon">
        <span class="svg-icon svg-icon-lg">
          <inline-svg src="media/svg/icons/General/User.svg"/>
        </span>
      </div>
      <div class="alert-text">
        <b>User Management Guide</b>
        In this section, you can view, search, edit users, change their roles, deactivate or delete them, recover their
        passwords, and check their activity history.
      </div>
    </b-alert>
    <div>
      <b-tabs fill>
        <b-tab title="Users" active>
          <TableUsers></TableUsers>
        </b-tab>
        <b-tab title="Roles">
          <p>
            <TableRoles></TableRoles>
          </p>
        </b-tab>
        <b-tab title="permissions">
          <p>
            <Permissions></Permissions>
          </p>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CodePreview.vue";
import KTCard from "@/view/content/Card.vue";
import Dropdown3 from "@/view/content/dropdown/Dropdown3.vue";
import TableUsers from "@/view/content/widgets/users/TableUsers.vue";
import TableRoles from "@/view/content/widgets/roles/TableRoles.vue";
import Permissions from "@/view/content/widgets/permission/permissions.vue";

export default {
  data() {
    return {
      form: {
        email: "",
        name: "",
        food: null,
        checked: []
      },
      foods: [
        {text: "Select One", value: null},
        "Carrots",
        "Beans",
        "Tomatoes",
        "Corn"
      ],
      show: true
    };
  },
  components: {
    Dropdown3,
    KTCard,
    KTCodePreview,
    TableUsers,
    TableRoles,
    Permissions,
  },
  methods: {},
  mounted() {
  }
};
</script>
